import { Button, MenuItem } from '@mui/material';


const ExportDatabaseButton = ({ isMenuItem = false, onClickExtra }) => {
  const handleExport = () => {
     const token = localStorage.getItem('jwtToken');
    fetch(`${process.env.REACT_APP_API_URL}/file-manager/export-excel`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(async response => {
        if (!response.ok) throw new Error('Errore nel download');

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'database.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        if (onClickExtra) onClickExtra();
      })
      .catch(error => {
        console.error('Errore esportazione Excel:', error);
        alert('Errore durante l\'esportazione del database.');
      });
  };

  return isMenuItem ? (
    <MenuItem onClick={handleExport}>Export Database</MenuItem>
  ) : (
    <Button color="inherit" sx={{ fontWeight: 'bold' }} onClick={handleExport}>
      Export Database
    </Button>
  );
};
export default ExportDatabaseButton;